import styled from "styled-components";

export const GreetingMessage = styled.div`
  text-align: left;
  font-size: 1.7em;
  margin-bottom: 10px;
  margin-left: 5px;
`;
